import React from "react";
import SeoMetadata from '../components/Seo/SeoMetadata';
import Header from "../components/layouts/Header";
import Footer from "../components/layouts/Footer";
import MaterialCalculator from "../components/sections/Calculadora/MaterialCalculator";
import TituloCalculadora from '../components/sections/Calculadora/TituloCalculadora';

const CalculadoraMaterialesPage = () => {
  return (
    <div>
      <SeoMetadata
        title="Calculadora de Materiales | Decototal"
        description="Calcula la cantidad aproximada de material que necesitas para tu proyecto con la calculadora Decototal. Elige un producto y estima tu compra."
        keywords="calculadora de materiales, calcular pisos, calcular recubrimientos, cantidad de material para construcción"
        path="/calculadora-materiales"
        image="/assets/img/contacto/banner-contacto.jpg"
      />
      <Header />
      <TituloCalculadora /> 
      <MaterialCalculator />
      <Footer />
    </div>
  );
};

export default CalculadoraMaterialesPage;